var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    height: 512,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.693107 512.511489m-511.488512 0a511.488511 511.488511 0 1 0 1022.977023 0 511.488511 511.488511 0 1 0-1022.977023 0Z",
    fill: "#FF4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.773371 685.451892c44.806394 0 81.01978-385.764635 81.01978-429.445754s-36.315684-79.178422-81.01978-79.178422-81.01978 35.395005-81.019781 79.178422 36.315684 429.445754 81.019781 429.445754z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.773371 685.451892c44.806394 0 81.01978-385.764635 81.01978-429.445754s-36.315684-79.178422-81.01978-79.178422-81.01978 35.395005-81.019781 79.178422 36.315684 429.445754 81.019781 429.445754z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M516.251493 726.677866c-38.873127 0-70.380819 30.791608-70.38082 68.744056s31.507692 68.744056 70.38082 68.744056 70.380819-30.791608 70.380819-68.744056-31.60999-68.744056-70.380819-68.744056z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M516.251493 726.677866c-38.873127 0-70.380819 30.791608-70.38082 68.744056s31.507692 68.744056 70.38082 68.744056 70.380819-30.791608 70.380819-68.744056-31.60999-68.744056-70.380819-68.744056z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPending);
export default __webpack_public_path__ + "static/media/order-pending.7ac542229f7f91c6bfb0d628346de34d.svg";
export { ForwardRef as ReactComponent };